export default (function (window) {
  window.Greenhouse = window.Greenhouse || {};
  window.Greenhouse.Translation = window.Greenhouse.Translation || {};
  window.Greenhouse.Translation.translations =
    window.Greenhouse.Translation.translations || {};

  return window.Greenhouse.Translation;
})(window);
